import SectionHead from "./SectionHead";
import { Reveal } from "./Reveal";
import { CONFIG } from "../i18n";

const List = ({ items, testid }) => (
  <ul className="creds">
    {items.map((x, i) => (
      <li key={i} data-testid={testid}>{x}</li>
    ))}
  </ul>
);

const About = ({ t }) => (
  <section className="section" id="about" data-testid="about-section">
    <div className="wrap about-grid">
      <Reveal className="portrait-wrap">
        <div className={`portrait ${CONFIG.photo ? "has-photo" : ""}`} data-testid="about-portrait">
          {CONFIG.photo ? (
            <img src={CONFIG.photo} alt="Cindy Silva, diseñadora de espacios digitales y miniapps" loading="lazy" />
          ) : (
            <>
              <span className="portrait-ring" aria-hidden="true" />
              <span className="initials serif-i" aria-hidden="true">CS</span>
              <p className="portrait-note mono">{t.photoNote}</p>
            </>
          )}
        </div>
      </Reveal>
      <div className="about-copy">
        <Reveal>
          <p className="eyebrow">{t.aboutLabel}</p>
          <h2>{t.aboutTitle}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p>{t.bio1}</p>
          <p>{t.bio2}</p>
          <p>{t.bio3}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <List items={t.creds} testid="about-creds" />
          <p className="eyebrow learn-label">{t.learnLabel}</p>
          <List items={t.learn} testid="about-learn" />
        </Reveal>
        <Reveal delay={0.2}>
          <aside className="fun-fact" data-testid="fun-fact-card">
            <p className="eyebrow">{t.funLabel}</p>
            <p className="fun-text">
              {t.funPre}<em className="serif-i">{t.funBook}</em>{t.funPost}
            </p>
          </aside>
          <p className="faith serif-i" data-testid="faith-quote">{t.faith}</p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
